
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Capture your love story with the best pre-wedding shoot in Goa. From stunning beaches to vibrant streets, create lasting memories in this beautiful destination.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the perfect locations in Goa for a magical pre-wedding shoot. From scenic landscapes to colorful streets, capture unforgettable moments before your big day.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Celebrate your love with a beautiful pre-wedding shoot in Goa. Capture stunning moments at Goa’s top locations, from beaches to iconic spots.',
},


        {
          hid: 'keywords',
          name: 'keywords',
          content: 'goa pre-wedding shoot, best pre-wedding shoot in goa, pre-wedding shoot in goa price, best place for pre-wedding shoot in goa, beach goa pre-wedding shoot, parra goa photography, romantic pre-wedding shoot in goa',
        },
      
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Locations",
      text: "Capture breathtaking views and hidden gems with the best photography spots in Goa!",
    },
    {
      title: "Perfect for Everyone",
      text: "Whether you're a pro or just starting, there's something for every photography lover!",
    },
    {
      title: "Local Experts",
      text: "Our experienced photographers guide you to the best locations and give helpful tips.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect photography experience easily through the Goa App at great rates!",
    },
  ],

     
      title: 'Pre-Wedding Shoot in Goa - Pre-Wedding Shoot in Goa Price and Location',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A10%3A33.913Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=NPSgUofBDYOy3MdtHoSWJpf9mLZr0La1Y5Q3QqznAriQKGoK8DnlLSQLVdo6TvihGm0XSJ5jyV1b7GSGlY5xsnY2c1qa2JRy17bGChpM4ciC3BmE3oJjr9UAnJ%2BK917OVZ7%2BYoqihHqXuiF6r3yvfx8sILJLOqg3VkIBvC8Bwtu7ZklmSaCSo%2B%2BsdfXaYLVJTEvcNXbVmawPbyA81yld9hUgFRDCFld0WVmgaOo6tAvZffd7nncVqEh6v9G8oLw75G406T%2FRPq%2FH%2FtMmpyucFxGC7SJKBDpKw2NpOB6gOaocKulSGRsjAXcZZL98NGYGceLWEgHDSrqg%2B75kq7GtnA%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A10%3A33.913Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=NPSgUofBDYOy3MdtHoSWJpf9mLZr0La1Y5Q3QqznAriQKGoK8DnlLSQLVdo6TvihGm0XSJ5jyV1b7GSGlY5xsnY2c1qa2JRy17bGChpM4ciC3BmE3oJjr9UAnJ%2BK917OVZ7%2BYoqihHqXuiF6r3yvfx8sILJLOqg3VkIBvC8Bwtu7ZklmSaCSo%2B%2BsdfXaYLVJTEvcNXbVmawPbyA81yld9hUgFRDCFld0WVmgaOo6tAvZffd7nncVqEh6v9G8oLw75G406T%2FRPq%2FH%2FtMmpyucFxGC7SJKBDpKw2NpOB6gOaocKulSGRsjAXcZZL98NGYGceLWEgHDSrqg%2B75kq7GtnA%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A10%3A33.913Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=NPSgUofBDYOy3MdtHoSWJpf9mLZr0La1Y5Q3QqznAriQKGoK8DnlLSQLVdo6TvihGm0XSJ5jyV1b7GSGlY5xsnY2c1qa2JRy17bGChpM4ciC3BmE3oJjr9UAnJ%2BK917OVZ7%2BYoqihHqXuiF6r3yvfx8sILJLOqg3VkIBvC8Bwtu7ZklmSaCSo%2B%2BsdfXaYLVJTEvcNXbVmawPbyA81yld9hUgFRDCFld0WVmgaOo6tAvZffd7nncVqEh6v9G8oLw75G406T%2FRPq%2FH%2FtMmpyucFxGC7SJKBDpKw2NpOB6gOaocKulSGRsjAXcZZL98NGYGceLWEgHDSrqg%2B75kq7GtnA%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/goa-pre-wedding-shoot`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/goa-pre-wedding-shoot`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A10%3A33.913Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=NPSgUofBDYOy3MdtHoSWJpf9mLZr0La1Y5Q3QqznAriQKGoK8DnlLSQLVdo6TvihGm0XSJ5jyV1b7GSGlY5xsnY2c1qa2JRy17bGChpM4ciC3BmE3oJjr9UAnJ%2BK917OVZ7%2BYoqihHqXuiF6r3yvfx8sILJLOqg3VkIBvC8Bwtu7ZklmSaCSo%2B%2BsdfXaYLVJTEvcNXbVmawPbyA81yld9hUgFRDCFld0WVmgaOo6tAvZffd7nncVqEh6v9G8oLw75G406T%2FRPq%2FH%2FtMmpyucFxGC7SJKBDpKw2NpOB6gOaocKulSGRsjAXcZZL98NGYGceLWEgHDSrqg%2B75kq7GtnA%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A10%3A33.913Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=NPSgUofBDYOy3MdtHoSWJpf9mLZr0La1Y5Q3QqznAriQKGoK8DnlLSQLVdo6TvihGm0XSJ5jyV1b7GSGlY5xsnY2c1qa2JRy17bGChpM4ciC3BmE3oJjr9UAnJ%2BK917OVZ7%2BYoqihHqXuiF6r3yvfx8sILJLOqg3VkIBvC8Bwtu7ZklmSaCSo%2B%2BsdfXaYLVJTEvcNXbVmawPbyA81yld9hUgFRDCFld0WVmgaOo6tAvZffd7nncVqEh6v9G8oLw75G406T%2FRPq%2FH%2FtMmpyucFxGC7SJKBDpKw2NpOB6gOaocKulSGRsjAXcZZL98NGYGceLWEgHDSrqg%2B75kq7GtnA%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/goa-pre-wedding-shoot`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Goa Pre-Wedding Shoot - Book @ ₹4999 Flat 17% Off",
  "description": "Enjoy the best pre-wedding shoot in Goa with stunning landscapes, vibrant culture, and unique moments captured for an unforgettable visual journey..",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A10%3A33.913Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=NPSgUofBDYOy3MdtHoSWJpf9mLZr0La1Y5Q3QqznAriQKGoK8DnlLSQLVdo6TvihGm0XSJ5jyV1b7GSGlY5xsnY2c1qa2JRy17bGChpM4ciC3BmE3oJjr9UAnJ%2BK917OVZ7%2BYoqihHqXuiF6r3yvfx8sILJLOqg3VkIBvC8Bwtu7ZklmSaCSo%2B%2BsdfXaYLVJTEvcNXbVmawPbyA81yld9hUgFRDCFld0WVmgaOo6tAvZffd7nncVqEh6v9G8oLw75G406T%2FRPq%2FH%2FtMmpyucFxGC7SJKBDpKw2NpOB6gOaocKulSGRsjAXcZZL98NGYGceLWEgHDSrqg%2B75kq7GtnA%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "4999",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/goa-pre-wedding-shoot",
        "url": "https://www.goa.app/goa-pre-wedding-shoot",
        "name": "Goa Pre-Wedding Shoot",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A10%3A33.913Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=NPSgUofBDYOy3MdtHoSWJpf9mLZr0La1Y5Q3QqznAriQKGoK8DnlLSQLVdo6TvihGm0XSJ5jyV1b7GSGlY5xsnY2c1qa2JRy17bGChpM4ciC3BmE3oJjr9UAnJ%2BK917OVZ7%2BYoqihHqXuiF6r3yvfx8sILJLOqg3VkIBvC8Bwtu7ZklmSaCSo%2B%2BsdfXaYLVJTEvcNXbVmawPbyA81yld9hUgFRDCFld0WVmgaOo6tAvZffd7nncVqEh6v9G8oLw75G406T%2FRPq%2FH%2FtMmpyucFxGC7SJKBDpKw2NpOB6gOaocKulSGRsjAXcZZL98NGYGceLWEgHDSrqg%2B75kq7GtnA%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A10%3A33.913Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=NPSgUofBDYOy3MdtHoSWJpf9mLZr0La1Y5Q3QqznAriQKGoK8DnlLSQLVdo6TvihGm0XSJ5jyV1b7GSGlY5xsnY2c1qa2JRy17bGChpM4ciC3BmE3oJjr9UAnJ%2BK917OVZ7%2BYoqihHqXuiF6r3yvfx8sILJLOqg3VkIBvC8Bwtu7ZklmSaCSo%2B%2BsdfXaYLVJTEvcNXbVmawPbyA81yld9hUgFRDCFld0WVmgaOo6tAvZffd7nncVqEh6v9G8oLw75G406T%2FRPq%2FH%2FtMmpyucFxGC7SJKBDpKw2NpOB6gOaocKulSGRsjAXcZZL98NGYGceLWEgHDSrqg%2B75kq7GtnA%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A10%3A33.913Z3.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=NPSgUofBDYOy3MdtHoSWJpf9mLZr0La1Y5Q3QqznAriQKGoK8DnlLSQLVdo6TvihGm0XSJ5jyV1b7GSGlY5xsnY2c1qa2JRy17bGChpM4ciC3BmE3oJjr9UAnJ%2BK917OVZ7%2BYoqihHqXuiF6r3yvfx8sILJLOqg3VkIBvC8Bwtu7ZklmSaCSo%2B%2BsdfXaYLVJTEvcNXbVmawPbyA81yld9hUgFRDCFld0WVmgaOo6tAvZffd7nncVqEh6v9G8oLw75G406T%2FRPq%2FH%2FtMmpyucFxGC7SJKBDpKw2NpOB6gOaocKulSGRsjAXcZZL98NGYGceLWEgHDSrqg%2B75kq7GtnA%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Best Pre-Wedding Shoot in Goa captures the stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for photography enthusiasts looking to frame beautiful sunsets, historic sites, and lush greenery.",
        "breadcrumb": {
            "@id": "https://www.goa.app/goa-pre-wedding-shoot/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/goa-pre-wedding-shoot"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
    "@type": "Question",
    "name": "What are the best locations for a pre-wedding shoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Some of the best locations for a pre-wedding shoot in Goa include Vagator Beach, Chapora Fort, Fontainhas, and Candolim Beach."
    }
  },
  {
    "@type": "Question",
    "name": "What types of pre-wedding photography services are available in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "In Goa, you can find various pre-wedding photography services, including couple shoots, romantic beach sessions, and themed photo shoots."
    }
  },
  {
    "@type": "Question",
    "name": "How much does a pre-wedding shoot cost in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Pre-wedding shoot packages in Goa typically start from ₹4,999, depending on the location and services included."
    }
  },
  {
    "@type": "Question",
    "name": "Can I customize my pre-wedding shoot package?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, many photographers in Goa offer customizable pre-wedding shoot packages tailored to your preferences and vision."
    }
  },
  {
    "@type": "Question",
    "name": "What is the best time for a pre-wedding shoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The best time for a pre-wedding shoot in Goa is during the golden hours, shortly after sunrise and before sunset, for stunning lighting."
    }
  },
  {
    "@type": "Question",
    "name": "Are there any restrictions on pre-wedding photography at certain locations?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, some locations in Goa may have restrictions on photography, especially private properties or during specific events. Always check beforehand."
    }
  },
  {
    "@type": "Question",
    "name": "Do pre-wedding photography packages include editing services?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Most pre-wedding photography packages in Goa include basic editing services, but you can request additional retouching for an extra fee."
    }
  },
  {
    "@type": "Question",
    "name": "Can I choose my pre-wedding shoot locations?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Absolutely! Many photographers will collaborate with you to choose locations that match your vision and preferences for the shoot."
    }
  },
  {
    "@type": "Question",
    "name": "What should I wear for a pre-wedding shoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Choosing comfortable and vibrant outfits that complement the scenery is recommended. Light fabrics and bright colors work well in Goa's sunny climate."
    }
  },
  {
    "@type": "Question",
    "name": "How do I book a pre-wedding shoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can book a pre-wedding shoot in Goa through various platforms, including the Goa App, where you can find reputable photographers and package details."
    }
  }
        ]
      }
    ]
  };
},


};



  